export default "__VITE_ASSET__D0kz9SNx__"